import React, { useContext, useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import ThemeToggleButton from "../helper/ThemeToggleButton";
import FavIcon from "../Assets/logo/fav.png";
import UserImage from "../Assets/user.png";
import { CiSearch } from "react-icons/ci";
import { StoreContext } from "../store/Store";
import "./MasterLayout.css";
import { toast } from "sonner";
import { RxCross1 } from "react-icons/rx";
import DashboardBarChart from "../charts/DashboardBarChart";
import DashboardPieChart from "../charts/DashboardPieChart";
import DashboardLineChart from "../charts/DashboardLineChart";
import DashboardDonutChart from "../charts/DashboardDonutChart";
import { encrypt } from "../Utils/Encryption";
import { GoArrowSwitch } from "react-icons/go";

const MasterLayout = ({ children }) => {
  const magicMysteryAIEmojis = [
    "🪄", // Magic wand
    "✨", // Sparkles
    "🧙", // Wizard
    "🧙‍♀️", // Female wizard
    "🧝", // Elf / mystical being
    "🤖", // Robot / AI
    "🛸", // UFO / mysterious
    "🔮", // Crystal ball
    "🕵️", // Detective / mystery
    "🗝️", // Key / secret
    "🧩", // Puzzle / enigmatic
    "🌀", // Swirl / mystical
    "🕳️", // Black hole / unknown
    "🦄", // Unicorn / magical
    "💫", // Shooting star / magic
    "👁️", // Eye / hidden knowledge
    "🌌", // Galaxy / mystery
    "⚡", // Lightning / magic energy
    "🪐", // Planet / cosmic mystery
    "📜", // Scroll / ancient knowledge
  ];

  const [sidebarActive, seSidebarActive] = useState(false);
  let [mobileMenu, setMobileMenu] = useState(false);
  const location = useLocation(); // Hook to get the current route
  const [searchInput, setSearchInput] = useState({
    table_name: "",
    column_name: "",
    input: "",
  });
  const [searchResultmodal, setSearchResultmodal] = useState(false);

  const navigate = useNavigate();

  const {
    logout,
    userid,
    getMasterTables,
    masterTables,
    getColumnForMasterTable,
    masterTableColumns,
    aiSearchResult,
    searchResult,
    searchResultLoader,
    parentMetrics,
    getParentMetrics,
    activeNavbar,
    setActiveNavbar,
    setUserid,
  } = useContext(StoreContext);

  useEffect(() => {
    const handleDropdownClick = (event) => {
      event.preventDefault();
      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest(".dropdown");

      if (!clickedDropdown) return;

      const isActive = clickedDropdown.classList.contains("open");

      // Close all dropdowns
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("open");
        const submenu = dropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = "0px"; // Collapse submenu
        }
      });

      // Toggle the clicked dropdown
      if (!isActive) {
        clickedDropdown.classList.add("open");
        const submenu = clickedDropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
        }
      }
    };

    // Attach click event listeners to all dropdown triggers
    const dropdownTriggers = document.querySelectorAll(
      ".sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link"
    );

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener("click", handleDropdownClick);
    });

    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll(".sidebar-submenu li a");
        submenuLinks.forEach((link) => {
          if (
            link.getAttribute("href") === location.pathname ||
            link.getAttribute("to") === location.pathname
          ) {
            dropdown.classList.add("open");
            const submenu = dropdown.querySelector(".sidebar-submenu");
            if (submenu) {
              submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
            }
          }
        });
      });
    };

    // Open the submenu that contains the active route
    openActiveDropdown();

    // Cleanup event listeners on unmount
    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener("click", handleDropdownClick);
      });
    };
  }, [location.pathname]);

  let sidebarControl = () => {
    seSidebarActive(!sidebarActive);
  };

  let mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };

  function handleLogout() {
    logout();
    setUserid(null);
    navigate("/sign-in");
  }

  useEffect(() => {
    const configid = localStorage.getItem("configid");
    getMasterTables(configid);
  }, []);

  async function handleSearchTable(item) {
    setSearchInput((prev) => ({ ...prev, table_name: item, column_name: "" }));
    const configid = localStorage.getItem("configid");
    await getColumnForMasterTable(configid, item);
  }

  async function handleSearchColumn(item) {
    setSearchInput((prev) => ({ ...prev, column_name: item }));
  }

  async function handleSearch(e) {
    e.preventDefault();
    const configid = localStorage.getItem("configid");
    const newInput = { ...searchInput, configid };

    if (!newInput.table_name) {
      toast.error("Please select a table name.");
      return;
    }
    if (!newInput.column_name) {
      toast.error("Please select a column name.");
      return;
    }
    if (!newInput.input) {
      toast.error("Please enter a search value.");
      return;
    }

    setSearchInput(newInput);
    aiSearchResult(newInput);
    setSearchResultmodal(true);
  }

  useEffect(() => {
    const configid = localStorage.getItem("configid");

    getParentMetrics(configid);
  }, []);
  console.log(parentMetrics);

  const renderChart = (chartType, metricData, i) => {
    switch (chartType) {
      case "Bar Chart":
        return <DashboardBarChart key={i} metricData={metricData} />;
      case "Pie Chart":
        return <DashboardPieChart key={i} metricData={metricData} />;
      case "Donut Chart":
        return <DashboardDonutChart key={i} metricData={metricData} />;
      case "Line Chart":
        return <DashboardLineChart key={i} metricData={metricData} />;
      default:
        return <p key={i}>No chart type found for {chartType}</p>;
    }
  };

  return (
    <section className={mobileMenu ? "overlay active" : "overlay "}>
      {/* sidebar */}
      <aside
        className={
          sidebarActive
            ? "sidebar active "
            : mobileMenu
            ? "sidebar sidebar-open"
            : "sidebar"
        }
      >
        <button
          onClick={mobileMenuControl}
          type="button"
          className="sidebar-close-btn"
        >
          <Icon icon="radix-icons:cross-2" />
        </button>
        <div>
          <Link to="/" className="sidebar-logo">
            <img
              src={"/assets/logo/cxobox.png"}
              alt="site logo"
              style={{
                marginLeft: "0px",
                display: sidebarActive ? "none" : "flex",
              }}
              className=""
            />
            {location.pathname === "/sign-in" ? (
              <img
                src="/assets/logo/cxobox.png"
                alt="site logo"
                style={{
                  marginLeft: "0px",
                  display: sidebarActive ? "none" : "flex",
                }}
                className=""
              />
            ) : (
              ""
            )}
            <img
              src={"/assets/logo/cxobox.png"}
              alt="site logo"
              className="dark-logo"
            />
            <img
              src={"/assets/logo/cxobox.png"}
              alt="site logo"
              className="dark-logo"
            />
          </Link>
        </div>
        <div className="sidebar-menu-area">
          <ul className="sidebar-menu" id="sidebar-menu">
            <p
              className="mt-3 mb-3"
              style={{
                fontSize: "0.75rem",
                fontWeight: 600,
                color: "#718096",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                marginBottom: "1rem",
              }}
            >
              Overview
            </p>

            <li onClick={setActiveNavbar(null)}>
              <NavLink
                to="/"
                className={(navData) => (navData.isActive ? "active-page" : "")}
                style={{ display: "flex", alignItems: "center" }}
              >
                <span>📊 Executive Overview</span>
              </NavLink>
            </li>

            <li onClick={setActiveNavbar(null)}>
              <NavLink
                to="/custom-metric"
                className={(navData) => (navData.isActive ? "active-page" : "")}
                style={{ display: "flex", alignItems: "center" }}
              >
                <span>🎯 AI Custom Metrics</span>
              </NavLink>
            </li>

            {/* <li onClick={setActiveNavbar(null)}>
              <NavLink
                to="/comparison-metric"
                className={(navData) => (navData.isActive ? "active-page" : "")}
                style={{ display: "flex", alignItems: "center" }}
              >
                <span>🪄 AI Comparision Metrics</span>
              </NavLink>
            </li> */}

            <li onClick={setActiveNavbar(null)}>
              <NavLink
                to="/chat-assistant"
                className={(navData) => (navData.isActive ? "active-page" : "")}
                style={{ display: "flex", alignItems: "center" }}
              >
                <span>
                  🤖 CXOBox.AI{" "}
                  {/* 🤖 {userid && (userid == 132 ? "Cloocus" : "VIZI 360")}{" "} */}
                  Assistant
                </span>
              </NavLink>
            </li>
          </ul>

          <ul className="sidebar-menu-metrics" id="sidebar-menu">
            <hr />
            <p
              className="mt-3 mb-3"
              style={{
                fontSize: "0.75rem",
                fontWeight: 600,
                color: "#718096",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
              }}
            >
              Metrics
            </p>

            {parentMetrics.map((item, idx) => (
              <li className="mb-2" key={item.id}>
                <NavLink
                  to={`/dashboard/childmetric/${item.metric_name}/${encrypt(
                    item.id.toString()
                  )}/0`}
                  className={item.id == activeNavbar ? "active-page" : ""}
                >
                  {/* <span>
                    <Icon
                      icon="mdi:chart-donut-variant"
                      className="menu-icon"
                    />
                  </span> */}
                  <div className="d-flex gap-1">
                    <span>
                      {/* {item.metric_name.length > 25
                      ? item.metric_name.slice(0, 22) + "..."
                      : item.metric_name} */}
                      {magicMysteryAIEmojis[idx % magicMysteryAIEmojis.length]}
                    </span>
                    <span>
                      {/* {item.metric_name.length > 25
                      ? item.metric_name.slice(0, 22) + "..."
                      : item.metric_name} */}
                      {item.metric_name}
                    </span>
                  </div>
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </aside>

      {searchResultmodal && (
        <div className="searchResultContainer">
          <div className="searchResultBgGradientContainer"></div>
          <div className="searchResultContainerMain">
            <div className="searchContainerClose">
              <p className="text-lg mb-0">Search Result</p>
              <button onClick={() => setSearchResultmodal(false)}>
                <RxCross1 className="searchCloseIcon" />
              </button>
            </div>
            {searchResultLoader ? (
              <div className="searchLoaderWrapper">
                <div className="searchLoaderspinner"></div>
              </div>
            ) : (
              <div className="searchResultContent">
                {(() => {
                  const filteredResults = searchResult.filter(
                    (item) => item.value && item.value.length > 0
                  );

                  return filteredResults.length > 0 ? (
                    filteredResults.map((item, i) => (
                      <div className="searchResultContentChart" key={i}>
                        {renderChart(item.chart_type, item, i)}
                      </div>
                    ))
                  ) : (
                    <div className="noResultsFound warning">
                      <p>
                        No results found. Please enter a valid entity or
                        currently there is no data available.
                      </p>
                    </div>
                  );
                })()}
              </div>
            )}
          </div>
        </div>
      )}

      <main
        className={sidebarActive ? "dashboard-main active" : "dashboard-main"}
      >
        <div className="navbar-header">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center gap-4">
                <button
                  type="button"
                  className="sidebar-toggle"
                  onClick={sidebarControl}
                >
                  {sidebarActive ? (
                    <Icon
                      icon="iconoir:arrow-right"
                      className="icon text-2xl non-active"
                    />
                  ) : (
                    <Icon
                      icon="heroicons:bars-3-solid"
                      className="icon text-2xl non-active "
                    />
                  )}
                </button>
              </div>
            </div>
            <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center gap-3">
                <div className="">
                  <form onSubmit={handleSearch} className="d-flex gap-3">
                    <div className="navbar-search">
                      <input
                        type="text"
                        className="bg-base h-40-px w-auto"
                        name="search"
                        placeholder="Search"
                        value={searchInput.input}
                        onChange={(e) =>
                          setSearchInput((prev) => ({
                            ...prev,
                            input: e.target.value,
                          }))
                        }
                      />
                      <Icon icon="ion:search-outline" className="icon" />
                    </div>
                    {searchInput.input.length >= 2 && (
                      <div className="dropdown ms-2">
                        <button
                          className="btn h-40-px px-18 py-11 dropdown-toggle toggle-icon"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            textTransform: "capitalize",
                            cursor: "pointer",
                            border: "1px solid #3a80c2",
                            color: "#3a80c2",
                          }}
                        >
                          {searchInput.table_name || "Select Table"}
                        </button>
                        <ul className="dropdown-menu">
                          {masterTables.map((item) => (
                            <li
                              key={item}
                              onClick={() => handleSearchTable(item)}
                              style={{
                                textTransform: "capitalize",
                                cursor: "pointer",
                              }}
                            >
                              <p className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900">
                                {item}
                              </p>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                    {searchInput.table_name && searchInput.input && (
                      <div className="dropdown ms-2">
                        <button
                          className="btn h-40-px px-18 py-11 dropdown-toggle toggle-icon"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            textTransform: "capitalize",
                            cursor: "pointer",
                            border: "1px solid #3a80c2",
                            color: "#3a80c2",
                          }}
                        >
                          {searchInput.column_name || "Select Column"}
                        </button>
                        <ul className="dropdown-menu">
                          {masterTableColumns.map((item) => (
                            <li
                              key={item}
                              onClick={() => handleSearchColumn(item)}
                              style={{
                                textTransform: "capitalize",
                                cursor: "pointer",
                              }}
                            >
                              <p className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900">
                                {item}
                              </p>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                    {searchInput.table_name &&
                      searchInput.column_name &&
                      searchInput.input && (
                        <button
                          type="submit"
                          className="btn text-light h-40-px px-18 py-11 ms-2"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "#3a80c2",
                          }}
                        >
                          Search
                        </button>
                      )}
                  </form>
                </div>
                {/* <div className="searchBox d-flex flex-wrap align-items-center">
                  <form className="navbar-search ">
                    <input
                      type="text"
                      className="bg-base h-40-px w-auto"
                      name="search"
                      placeholder="Search"
                    />
                    <Icon icon="ion:search-outline" className="icon" />
                  </form>
                  <form className="searchBoxForm">
                    <input
                      type="text"
                      className="searchBoxFormInput"
                      placeholder="Search"
                      value={searchInput.input}
                      onChange={(e) =>
                        setSearchInput((prev) => ({
                          ...prev,
                          input: e.target.value,
                        }))
                      }
                    />
                    <select
                      className="searchBoxFormDropdown"
                      onChange={handleSearchTable}
                    >
                      <option value="select" selected disabled>
                        Select Table
                      </option>
                      {masterTables.map((item) => (
                        <option value={item}>{item}</option>
                      ))}
                    </select>
                    <select
                      className="searchBoxFormDropdown"
                      onChange={handleSearchColumn}
                    >
                      <option value="select" selected disabled>
                        Select Column
                      </option>
                      {masterTableColumns.map((item) => (
                        <option value={item}>{item}</option>
                      ))}
                    </select>
                  </form>
                  <button
                    className="searchBoxFormButton"
                    onClick={handleSearch}
                  >
                    <CiSearch className="searchBoxFormButtonIcon" />
                  </button>
                </div> */}
                <Link
                  to={"/database-configurations"}
                  className="d-flex justify-content-center align-items-center rounded-circle w-36-px h-36-px"
                  style={{
                    border: "1px solid #ccc",
                  }}
                >
                  <GoArrowSwitch className="w-30-px h-30-px object-fit-cover rounded-circle" />
                </Link>
                <div className="dropdown">
                  <button
                    className="d-flex justify-content-center align-items-center rounded-circle"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    <img
                      src={UserImage}
                      alt="image_user"
                      className="w-36-px h-36-px object-fit-cover rounded-circle"
                    />
                  </button>
                  <div className="dropdown-menu to-top dropdown-menu-sm">
                    {/* <div className="py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2">
                      <div>
                        <h6 className="text-lg text-primary-light fw-semibold mb-2">
                          John Doe (Name)
                        </h6>
                        <span className="text-secondary-light fw-medium text-sm">
                          Client
                        </span>
                      </div>
                      <button type="button" className="hover-text-danger">
                        <Icon
                          icon="radix-icons:cross-1"
                          className="icon text-lg"
                        />
                      </button>
                    </div> */}
                    <ul className="to-top-list">
                      <li onClick={handleLogout}>
                        <Link
                          className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3"
                          to="sign-in"
                        >
                          <Icon icon="lucide:power" className="icon text-lg" />{" "}
                          Log Out
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* Profile dropdown end */}
              </div>
            </div>
          </div>
        </div>

        {/* dashboard-main-body */}
        <div className="dashboard-main-body " style={{ background: "#f2f2f2" }}>
          {children}
        </div>

        {/* Footer section */}
        <footer className="d-footer">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <p className="mb-0">
                © 2026 CXOBox.AI | All Rights Reserved. © 2026{" "}
                {/* {userid && (userid == 132 ? "Cloocus" : "VIZI 360")} All Rights
                Reserved. */}
              </p>
            </div>
            <div className="col-auto">
              <p className="mb-0">
                {/* Made by <span className='text-primary-600'>wowtheme7</span> */}
              </p>
            </div>
          </div>
        </footer>
      </main>
    </section>
  );
};

export default MasterLayout;
